export default {
  reports_range_days: 90,
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-analytic/features/config.js